import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './orderFillsByVenueTypeCapsulePreview.png';

export const orderFillsByVenueTypeCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>This capsule displays your order&apos;s venue type usage.</div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'order-fills-by-venue-capsule-chart-preview',
        },
    ],
};
